export class EdutrakAPIRequest {
  send() {
    throw new Error(
      "Method `send` must be implemented by classes extending EdutrakAPIRequest!"
    );
  }
}
